import {Button} from '@wandb/weave/components/Button';
import {FC, useCallback, useContext, useMemo} from 'react';
import React from 'react';
import {useHistory} from 'react-router-dom';

import {
  useEntityProject,
  useWeaveflowRouteContext,
  WeaveflowPeekContext,
} from '../../context';

export interface TurnMetadataProps {
  turnId: string;
  turnNumber?: number;
  hasTurnCalls?: boolean;
}

export const TurnMetadata: FC<TurnMetadataProps> = ({
  turnId,
  turnNumber,
  hasTurnCalls,
}) => {
  const {peekingRouter, baseRouter} = useWeaveflowRouteContext();
  const {entity, project} = useEntityProject();
  const {setPreviousUrl, isPeeking} = useContext(WeaveflowPeekContext);
  const history = useHistory();

  const to = useMemo(() => {
    // If we're already in a peek view, use peekingRouter to open another peek
    // If we're not in a peek view, use baseRouter for normal navigation
    const router = isPeeking ? peekingRouter : baseRouter;
    return router.callUIUrl(entity, project, '', turnId, turnId, false, false);
  }, [entity, project, turnId, peekingRouter, baseRouter, isPeeking]);

  const handleClick = useCallback(() => {
    if (setPreviousUrl && isPeeking) {
      // Only store previousUrl if we're in a peek view
      const currentUrl = window.location.pathname + window.location.search;
      setPreviousUrl(currentUrl);
    }
    history.push(to);
  }, [setPreviousUrl, isPeeking, history, to]);

  // If turnNumber is provided, render the full turn header
  if (turnNumber !== undefined) {
    return (
      <div className="flex items-center gap-x-8">
        {turnNumber !== undefined && (
          <span className="w-max whitespace-nowrap text-sm text-moon-500">
            Turn {turnNumber}
          </span>
        )}
        {hasTurnCalls === false && (
          <div className="mr-auto flex w-full items-center gap-x-4 whitespace-nowrap text-sm text-moon-600">
            <span className={'font-semibold'}>Non-chat call:</span>
            <span>inspect call for details.</span>
          </div>
        )}
        <div className="ml-auto flex items-center opacity-0 group-hover:opacity-100">
          <Button
            size="small"
            variant="ghost"
            endIcon="open-new-tab"
            onClick={handleClick}>
            View call
          </Button>
        </div>
      </div>
    );
  }

  // Default behavior: just render the button
  return (
    <Button
      size="small"
      variant="ghost"
      endIcon="open-new-tab"
      onClick={handleClick}>
      View call
    </Button>
  );
};
